<script lang="ts">

    export let show: any = false;

</script>

{#if show}
    <div class="feedback">
        <slot />
    </div>
{/if}

<style lang="scss">

    .feedback {
        font-size: 0.85rem;
        background-color: var(--color-invalid);
        color: #fff;
        margin: 0.5rem 0;
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
    }

</style>
